import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BaseAPI as _BaseAPI } from '@repo/components';

@Injectable({
  providedIn: 'root',
})
export class BaseAPI extends _BaseAPI {
  // noinspection JSUnusedGlobalSymbols
  protected readonly BASE_URL = environment.apiBaseUrl;
  protected readonly http = inject(HttpClient);
}
